import { render, staticRenderFns } from "./activityPrice.vue?vue&type=template&id=a83300fe&scoped=true&"
import script from "./activityPrice.vue?vue&type=script&lang=js&"
export * from "./activityPrice.vue?vue&type=script&lang=js&"
import style0 from "./activityPrice.vue?vue&type=style&index=0&id=a83300fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83300fe",
  null
  
)

export default component.exports